import { FunctionComponent, useCallback } from 'react'

import { useTheme } from 'styled-components'

import config from '@config'
import { setLocalStorageItem } from '@utils/localStorage'
import translate from '@i18n'

import {
  TextWrapper,
  TooltipCloseButton,
  TooltipContainer,
  TooltipLink,
  TooltipText,
  TooltipTitle,
} from './FmtTooltipReusableComponents'

type FmtOnboardingTooltipContentProps = {
  setShouldShowTooltip: (shouldShow: boolean) => void
  teamName?: string
}

const {
  fmtOnboarding: { localStorageHideFmtOnboardingTooltipKey, moreInfoLink },
} = config

const FmtOnboardingTooltipContent: FunctionComponent<
  FmtOnboardingTooltipContentProps
> = ({ setShouldShowTooltip, teamName }) => {
  const theme = useTheme()

  const onClose = useCallback(() => {
    setLocalStorageItem(localStorageHideFmtOnboardingTooltipKey, 'true')
    setShouldShowTooltip(false)
  }, [setShouldShowTooltip])

  const titleTranslation = teamName
    ? translate('fmtOnboardingTooltip.teamPage.title')
    : translate('fmtOnboardingTooltip.sportHome.title')

  const textTranslation = teamName
    ? translate('fmtOnboardingTooltip.teamPage.text', {
        teamName: teamName,
      })
    : translate('fmtOnboardingTooltip.sportHome.text')

  return (
    <TooltipContainer>
      <TextWrapper>
        <TooltipTitle>{titleTranslation}</TooltipTitle>
        <TooltipText>{textTranslation}</TooltipText>
      </TextWrapper>
      <TooltipCloseButton
        type="button"
        iconName="xmark-large"
        iconSize={24}
        iconColor={theme.colors.iconDefault}
        ariaLabel="close"
        onClick={onClose}
      />
      <TooltipLink
        href={moreInfoLink}
        target="_blank"
        rel="noopener noreferrer"
        onClick={onClose}>
        {translate('fmtOnboardingTooltip.moreInfo')}
      </TooltipLink>
    </TooltipContainer>
  )
}

export default FmtOnboardingTooltipContent
